export default function getPhraseLength(phrase, input) {
  if (Array.isArray(phrase) && phrase.indexOf(input) > -1) {
    return phrase[phrase.indexOf(input)].split(" ").length;
  } else {
    return phrase ? phrase.split(" ").length : 0;
  }
}
